import { render, staticRenderFns } from "./SmLookupCategoryDialog.vue?vue&type=template&id=87a4609e&"
import script from "./SmLookupCategoryDialog.vue?vue&type=script&lang=js&"
export * from "./SmLookupCategoryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports